/**
 * Created by BFR on 29/01/2018.
 */
define('orderStatusDetailTabController',[
  'module',
  'underscore',
  'backbone',
  'app',
  'orderStatusDetailView',
  'settings'
], function(
  module,
  _,
  Backbone,
  App,
  View
) {
  'use strict';

  var OrderStatusDetailTabController = {
    showTab: function(data) {
      if (!data.tab) {
        data.tab = 'detail';
      }
      this.showOrderStatusInfo(data);
    },

      showOrderStatusInfo: function(data) {
      var that = this;
      this.model = data.model;
      this.tab = data.tab;
      this.data = data;
      that.createView();
    },

    createView: function() {
      var view;
      view = new View({
        model: this.model
      });
      view.tempModel = new Backbone.Model(this.model.toJSON());
      this.view = view;

      App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('orderStatusDetailTab').show(view);
    }
  };

  module.exports = OrderStatusDetailTabController;
});
